webpackJsonp([26],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("grSL");


/***/ }),

/***/ "LNgB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "grSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_list_models_catalog_vn_scss__ = __webpack_require__("LNgB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_list_models_catalog_vn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scss_list_models_catalog_vn_scss__);


$(document).ready(function () {
  var filterItems = $('.makers-vn-energy_item[data-energy-filter]');
  var newModelRow = $('#newModelRow');
  var newModelSection = $('#newModelSection');

  filterItems.on('click', function () {

    if ($(this).hasClass('current')) {
      $(this).removeClass('current');
      $('.col-model').removeClass('d-none');
      if (newModelSection) {
        newModelSection.removeClass('d-none');
      }
      return;
    }

    var dataEnergy = $(this).data('energy-filter');

    $('.col-model').each(function () {
      if (!$(this).hasClass(dataEnergy)) {
        $(this).addClass('d-none');
      } else {
        $(this).removeClass('d-none');
      }
    });

    if (newModelRow) {
      var newModelItems = newModelRow.find('.col-model');
      var shouldHideNewModelSection = true;

      newModelItems.each(function () {
        if (!$(this).hasClass('d-none')) {
          shouldHideNewModelSection = false;
        }
      });

      if (shouldHideNewModelSection) {
        newModelSection.addClass('d-none');
      } else {
        newModelSection.removeClass('d-none');
      }
    }

    $('.makers-vn-energy_item').removeClass('current');
    $(this).addClass('current');
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ })

},[40]);


// WEBPACK FOOTER //
// list-models-catalog-vn.295d2ed64a01788100b7.js